/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createReservationsRepository = (options: RestApiOptions): Types.ReservationsRepository => ({
    async addNotes(params, requestOptions) {
        return options.request('/reservations/addNotes', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async addProductOrder(params, requestOptions) {
        return options.request('/reservations/addProductOrder', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async adjustDefaultProductOrderAmount(params, requestOptions) {
        return options.request('/reservations/adjustDefaultProductOrderAmount', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async assignSlot(params, requestOptions) {
        return options.request('/reservations/assignSlot', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async cancel(params, requestOptions) {
        return options.request('/reservations/cancel', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async checkIn(params, requestOptions) {
        return options.request('/reservations/checkIn', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async checkOut(params, requestOptions) {
        return options.request('/reservations/checkOut', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async confirm(params, requestOptions) {
        return options.request('/reservations/confirm', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async deleteNotes(params, requestOptions) {
        return options.request('/reservations/deleteNotes', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getAll(params, requestOptions) {
        return options.request('/reservations/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getRequestedCategoryUpdatePriceDifference(params, requestOptions) {
        return options.request('/reservations/getRequestedCategoryUpdatePriceDifference', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getUpdateIntervalCancellationFee(params, requestOptions) {
        return options.request('/reservations/getUpdateIntervalCancellationFee', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async makeOptional(params, requestOptions) {
        return options.request('/reservations/makeOptional', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async optimizeAssignment(params, requestOptions) {
        return options.request('/reservations/optimizeAssignment', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async previewAssignment(params, requestOptions) {
        return options.request('/reservations/previewAssignment', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async price(params, requestOptions) {
        return options.request('/reservations/price', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async search(params, requestOptions) {
        return options.request('/reservations/search', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async searchNew(params, requestOptions) {
        return options.request('/reservations/searchNew', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async sendEmail(params, requestOptions) {
        return options.request('/reservations/sendEmail', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async setAverageDefaultProductOrderAmount(params, requestOptions) {
        return options.request('/reservations/setAverageDefaultProductOrderAmount', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async setDefaultProductOrderAmount(params, requestOptions) {
        return options.request('/reservations/setDefaultProductOrderAmount', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async split(params, requestOptions) {
        return options.request('/reservations/split', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async undoCancellation(params, requestOptions) {
        return options.request('/reservations/undoCancellation', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async undoCheckIn(params, requestOptions) {
        return options.request('/reservations/undoCheckIn', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async undoCheckOut(params, requestOptions) {
        return options.request('/reservations/undoCheckOut', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async update(params, requestOptions) {
        return options.request('/reservations/update', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateAssignedAndRequestedCategory(params, requestOptions) {
        return options.request('/reservations/updateAssignedAndRequestedCategory', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateAssignedResource(params, requestOptions) {
        return options.request('/reservations/updateAssignedResource', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateBooker(params, requestOptions) {
        return options.request('/reservations/updateBooker', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateBusinessSegment(params, requestOptions) {
        return options.request('/reservations/updateBusinessSegment', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateChannelNumber(params, requestOptions) {
        return options.request('/reservations/updateChannelNumber', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateInterval(params, requestOptions) {
        return options.request('/reservations/updateInterval', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateLocked(params, requestOptions) {
        return options.request('/reservations/updateLocked', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateNotes(params, requestOptions) {
        return options.request('/reservations/updateNotes', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateOrigin(params, requestOptions) {
        return options.request('/reservations/updateOrigin', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateOwner(params, requestOptions) {
        return options.request('/reservations/updateOwner', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updatePartnerCompany(params, requestOptions) {
        return options.request('/reservations/updatePartnerCompany', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updatePersonCount(params, requestOptions) {
        return options.request('/reservations/updatePersonCount', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updatePurchaseOrderNumber(params, requestOptions) {
        return options.request('/reservations/updatePurchaseOrderNumber', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateRate(params, requestOptions) {
        return options.request('/reservations/updateRate', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateReleased(params, requestOptions) {
        return options.request('/reservations/updateReleased', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updateTravelAgency(params, requestOptions) {
        return options.request('/reservations/updateTravelAgency', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
